module.exports = __webpack_public_path__ + "img/bookshelf14.c99b219f.jpg";